import React, { Component } from 'react';
import * as Func from '../../../../../../helpers/functions';
import * as HMS from "../../../../common/component/Index";
import EllipsisText from '../../../../common/component/EllipsisText';
import { checkUndefine } from "../../../../../../helpers/functions";
import AntSelect, { AntOption } from '../../../../common/component/AntSelect';
import Wrapper from './../../../../common/component/Wrapper';
import { Input, Modal, Icon, List, Tooltip, Radio, message } from 'antd';
import CoInput from "../../../../common/component/Input";
import "./styles.less";
import { cloneDeep, filter, findIndex, includes, sumBy } from 'lodash';
import i18n from '../../../../../../constants/initLng';

export default class ChangeRateCode extends Component {
    constructor(props) {
        super(props);
        this.state = {
            componentTable: {
                name: {
                    key: 'name',
                    render: (name, record) => name && <EllipsisText title={name} content={name} contentMaxWidth={280}
                    overlayClassName={'max-width-500'} overlayComponent={Tooltip} />
                },
                cashFlow: {
                    key: 'cashFlow',
                    render: (cashFlow, record, index) => 
                        <span>{index === 0 ? this.props.t('item.changeRateCode.cancelCashFlow') : this.props.t('item.changeRateCode.changeCashFlow')}</span>
                },
                sellCost: {
                    key: 'sellCost',
                    render: (sellCost, record, index) => <span>{index === 0 ? '- ' : ''}{Func.formatMoney(sellCost)}</span>
                },
            },
            isSubmit: false,
            action: 1,
            isActive: [],
            rateCodeCurrent: {},
            rateCodeSelect: [],
            valueSearch: '',
            arrRateCode: [],
            pageIndex: 1,
            pageSize: 20,
            totalCount: 0,
            isUsePagingRateCode: true,
            campaign: null,
            ftCode: '',
            isErrorFt: false,
            additionalPayment: {
                sellCost: 0,
                additionalCode: '',
                name: '',
                rounding: 0,
                roundingShow: 0,
                sellCostShow: 0,
            }
        };
    }

    componentDidMount() {
        this.loadData();
        if (this.props.visible) {
            this.loadRateCodeData();
        }
    }

    componentWillUnmount() {
        if(this.searchTimer){
            clearTimeout(this.searchTimer);
        }
    }

    componentDidUpdate(prev){
        const isModalOpened = this.props.visible && !prev.visible;

        if(isModalOpened){
            this.loadRateCodeData();
        }
        if(!isModalOpened){
            if(this.props.visible && this.props.productType && prev.productType !== this.props.productType){
                this.loadRateCodes({ pageIndex: 1 });
            }
            if(this.props.visible && this.props.rateCodeId && prev.rateCodeId !== this.props.rateCodeId){
                this.loadCurrentRateCode();
            }
        }
        if(this.props.rateCodeState.rateCodePaging !== prev.rateCodeState.rateCodePaging){
            this.setState({
                arrRateCode: this.props.rateCodeState.rateCodePaging || [],
                pageIndex: this.props.rateCodeState.rateCodePagingPageIndex || this.state.pageIndex,
                pageSize: this.props.rateCodeState.rateCodePagingPageSize || this.state.pageSize,
                totalCount: this.props.rateCodeState.rateCodePagingTotalCount || 0,
                isUsePagingRateCode: true,
            });
        }
        if(this.props.rateCodeState.rateCodeAll !== prev.rateCodeState.rateCodeAll && !this.state.isUsePagingRateCode){
            this.setFallbackRateCodes();
        }
        if(this.props.rateCodeState.rateCodeDetailMap !== prev.rateCodeState.rateCodeDetailMap){
            const rateCodeCurrent = this.props.rateCodeState.rateCodeDetailMap?.[this.props.rateCodeId];
            if(rateCodeCurrent){
                this.setState({ rateCodeCurrent });
            }
        }
    }

    loadData() {
        this.props.getRateCodeCampaignList();
    }

    loadRateCodeData = () => {
        this.loadCurrentRateCode();
        this.loadRateCodes({ pageIndex: 1 });
    }

    getRateCodePagingParams = (params = {}) => {
        const pageIndex = params.pageIndex || this.state.pageIndex;
        const pageSize = params.pageSize || this.state.pageSize;
        const searchTerm = params.searchTerm !== undefined ? params.searchTerm : this.state.valueSearch;
        const campaignId = params.campaignId !== undefined ? params.campaignId : this.state.campaign;
        return {
            productType: this.props.productType,
            pageIndex,
            pageSize,
            ...(searchTerm ? { searchTerm } : {}),
            ...(campaignId ? { campaignId } : {}),
        };
    }

    loadRateCodes = (params = {}) => {
        if(!this.props.productType){
            return;
        }
        const nextParams = this.getRateCodePagingParams(params);
        this.props.getRateCodeListWithPaging(nextParams, {
            callbacks: {
                onSuccess: (result) => {
                    this.setState({
                        arrRateCode: result.result || [],
                        pageIndex: result.pageIndex || nextParams.pageIndex,
                        pageSize: result.pageSize || nextParams.pageSize,
                        totalCount: result.totalCount || 0,
                        isUsePagingRateCode: true,
                    });
                },
                onError: () => this.loadFallbackRateCodes(),
            }
        });
    }

    loadCurrentRateCode = () => {
        const { rateCodeId, rateCodeState } = this.props;
        if(!rateCodeId) return;
        const cachedRateCode = rateCodeState.rateCodeDetailMap?.[rateCodeId];
        if(cachedRateCode){
            this.setState({ rateCodeCurrent: cachedRateCode });
            return;
        }
        this.props.getRateCodeDetailCache(rateCodeId, {
            callbacks: {
                onSuccess: (rateCode) => this.setState({ rateCodeCurrent: rateCode }),
                onError: () => this.loadFallbackRateCodes(),
            }
        });
    }

    loadFallbackRateCodes = () => {
        this.setState({ isUsePagingRateCode: false });
        this.props.getRateCodeListAll();
    }

    setFallbackRateCodes = () => {
        const { rateCodeAll } = this.props.rateCodeState;
        const arrTmp = (rateCodeAll || []).filter(item => item.productTypes.includes(this.props.productType));
        const rateCodeCurrent = (rateCodeAll || []).find(item => item.id === this.props.rateCodeId);
        this.setState({
            arrRateCode: arrTmp,
            totalCount: arrTmp.length,
            pageIndex: 1,
            rateCodeCurrent: rateCodeCurrent || this.state.rateCodeCurrent,
        });
    }

    renderFooter = ()=>{
        const { t } = this.props;
        const { rateCodeSelect, rateCodeCurrent } = this.state;
        // let textProductSelect = '';
        let textProductCurrent = '';
        // if(rateCodeSelect.rateCodeProducts && rateCodeSelect.rateCodeProducts.length > 0){
        //     textProductSelect = rateCodeSelect.rateCodeProducts.map((it, idx)=>{
        //         return it.code && `${it.code}(${Func.formatMoney(it.cost || 0)})`
        //     }).join(' - ')
        // }
        if(rateCodeCurrent.rateCodeProducts && rateCodeCurrent.rateCodeProducts.length > 0){
            textProductCurrent = rateCodeCurrent.rateCodeProducts.map((it, idx)=>{
                return it.code && `${it.code}(${Func.formatMoney(it.cost || 0)})`
            }).join(' - ')
        }
        return(
            <Wrapper>
                <Wrapper className="fw-bold footer-change">
                    {t('item.changeRateCode.contentChange')}
                </Wrapper>
                <Wrapper>
                    <span className="fw-bold mr-25">{t('item.changeRateCode.from')}:</span>
                    <span className="fw-bold">{rateCodeCurrent.code} ({Func.formatMoney(rateCodeCurrent.sellCost)})</span>{textProductCurrent && `: ${textProductCurrent}`}
                </Wrapper>
                <Wrapper>
                <span className="fw-bold mr-10">{t('item.changeRateCode.to')}:</span>
                {
                    rateCodeSelect.map(rateCode => {
                        let textProductSelect = '';
                        const unitTypeValue = rateCode?.interestUnitType === 1 ? '[%]' : "[$]";
                        if(rateCode.rateCodeProducts && rateCode.rateCodeProducts.length > 0){
                            textProductSelect = rateCode.rateCodeProducts.map((it, idx)=>{
                                return it.code && `${it.code}(${Func.formatMoney(it.cost || 0)})`
                            }).join(' - ')?.toUpperCase()
                        }
                        return (
                            <div className='col-12' key={rateCode.id}>
                                <span className="fw-bold">
                                    {rateCode.code} {unitTypeValue} ({Func.formatMoney(rateCode.sellCost)})
                                </span>
                                {textProductSelect && `: ${textProductSelect}\n`}
                            </div>
                        )
                    })
                }
                {/* <span className="fw-bold">{rateCodeSelect.code} ({Func.formatMoney(rateCodeSelect.sellCost)})</span>{textProductSelect && `: ${textProductSelect}`} */}
                </Wrapper>
            </Wrapper>
        )
    }

    selectFilterSearch = (input, option) => {
        const optionText = Func.vietnameseStringToUnicode(option.props.children.toLowerCase());
        const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0;
    }

    renderHeader = ()=> {
        const { t, rateCodeState } = this.props;
        const { rateCodeCampaigns } = rateCodeState;
        const { campaign } = this.state;
        return(
            <div style={{display: 'flex'}}>
                <Wrapper className='col-md-6 pl-0 header-change'>
                    <span className="fw-bold">{t(`item.changeRateCode.search`)}</span>
                    <Input.Search placeholder="" type={`text`}
                        name={`valueSearch`} onChange={(e) => this.onChange('valueSearch', e.target.value)}
                        value={checkUndefine(this.state.valueSearch)} 
                    />
                </Wrapper>
                <Wrapper className='col-md-6 pl-0 pr-0 header-change'>
                    <span className="fw-bold">{t(`item.changeRateCode.searchCampaign`)}</span>
                    <AntSelect className="select-types"
                        showArrow showSearch
                        suffixIcon={<Icon type="search" />}
                        filterOption={this.selectFilterSearch}
                        placeholder={ Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.ratecode.campaign")).toLowerCase()) }
                        value={ campaign }
                        onChange={ campaign => this.onChange('campaign', campaign) }
                        style={ { width: '100%' } }
                    >
                        <AntOption key={ 'all' } value={ null }>Tất cả</AntOption>
                        { (rateCodeCampaigns || []).map(item => (
                            <AntOption key={ item.id } value={ item.id }>
                                { item.name }
                            </AntOption>
                        )) }
                    </AntSelect>
                </Wrapper>
            </div>
        )
    }

    renderInputAdditional = ({ key = '', translate = '', type = 'text' }) => {
        const { t } = this.props;
        const { additionalPayment } = this.state;

        return (
            <div className='col-md-8' >
                <div className='row'>
                    <span className="change-rate-code-addition-info col-md-4">{t(`item.changeRateCode.${translate}`)}</span>
                    <CoInput
                        className='col-md-8'
                        style={{ }}
                        placeholder=""
                        type={type}
                        name={key} onChange={(e) => this.onChangeAdditionalValue(key, e.target.value)}
                        value={checkUndefine(additionalPayment?.[key])} 
                    />
                </div>
            </div>
        )
    }

    render() {
        const { t, visible, rateCodeId } = this.props;
        const { action, isActive, arrRateCode, componentTable, rateCodeCurrent, rateCodeSelect, ftCode, isErrorFt,
            additionalPayment, pageIndex, pageSize, totalCount, isUsePagingRateCode,
        } = this.state;
        return (
            <Modal className="change-rate-code"
                width={900}
                destroyOnClose={true}
                visible={visible}
                title={t(`item.changeRateCode.title`)}
                okButtonProps={{disabled: (additionalPayment.rounding < 0 && action === 2)}}
                onOk={()=> this.onSubmit(action)} okText={action === 1 ? t(`action.changeRate`) : t(`action.saveChangeRate`)}
                onCancel={()=> this.onCancel(action)} cancelText={action === 1 ? t(`action.cancel`) : t(`action.back`)}
            >
                { action === 1 ? 
                    <Wrapper className="col-md-12">
                        <List 
                            itemLayout="horizontal"
                            dataSource={(arrRateCode || []).filter(item => item.id !== rateCodeId)}
                            pagination={isUsePagingRateCode ? {
                                current: pageIndex,
                                pageSize,
                                total: totalCount,
                                showSizeChanger: false,
                                onChange: this.onPageChange,
                            } : {defaultPageSize: 10}}
                            header={this.renderHeader()}
                            // footer={isActive.length > 0 && this.renderFooter()}
                            footer={rateCodeSelect.length > 0 && this.renderFooter()}
                            bordered
                            renderItem={item => {
                                let textProduct = '';
                                if(item.rateCodeProducts && item.rateCodeProducts.length > 0){
                                    textProduct = item.rateCodeProducts.map((it, idx)=>{
                                        return it.code && `${it.code}(${Func.formatMoney(it.cost || 0)})`
                                    }).join(' - ')
                                }

                                const isChoose = findIndex(rateCodeSelect, ratecode => ratecode.id === item.id) >= 0;
                                return (
                                    <List.Item className={`item-change-rate-code ${isChoose && 'isChoose'}`} onClick={()=> this.onHandleRateCode(item)}>
                                        <span className="fw-bold">{item.code} ({Func.formatMoney(item.sellCost)})</span>{textProduct && `: ${textProduct}`}
                                    </List.Item>
                                )
                            }}
                        />
                    </Wrapper>
                    : <Wrapper>
                        <Wrapper>
                            <div className="change-rate-code-note">{t('item.changeRateCode.note')}</div>
                            <div>{t('item.changeRateCode.noteContent')}</div>
                            <div>{t('item.changeRateCode.noteContentChangeRateCode')}</div>
                        </Wrapper>
                        <Wrapper>
                            <div className="change-rate-code-cashFlow">{t('item.changeRateCode.cashFlow')}</div>
                            <HMS.ListComponent
                                classChildren="p-0 m-0"
                                marginTop={'0'} marginBottom={'0'}
                                rowKey={(record, k) => k}
                                // dataSource={Func.getDataSource([rateCodeCurrent, rateCodeSelect], ['name', 'code', 'cashFlow', 'sellCost'])}
                                dataSource={Func.getDataSource([rateCodeCurrent, ...rateCodeSelect], ['name', 'code', 'cashFlow', 'sellCost'])}
                                columns={Func.columnsTable({ titleTable: ['name', 'code', 'cashFlow', 'sellCost'], component: componentTable, itemName: 'changeRateCode' })}
                            />
                        </Wrapper>
                        {
                            (sumBy(rateCodeSelect, "sellCost") - rateCodeCurrent.sellCost) !== 0 && 
                            rateCodeSelect.length > 1
                            ?   <Wrapper className='row row mt-15 mb-10'>
                                    <p className="change-rate-addition-cost col-md-6">
                                        {t("item.changeRateCode.newIssueCostAmount", {
                                            cost: Func.formatMoney(
                                                sumBy(rateCodeSelect, "sellCost") -
                                                rateCodeCurrent.sellCost
                                            ),
                                        })}
                                    </p>
                                    {/* <Radio.Group
                                        onChange={() => {}}
                                        value={(sumBy(rateCodeSelect, "sellCost") - rateCodeCurrent.sellCost) > 0}
                                        className="radio-type-export mt-2 mb-2 col-md-12"
                                    >
                                        <Radio className='d-block' value={false}>{t("item.changeRateCode.nonAdditionalPayment")}</Radio>
                                        <Radio className='d-block mt-2 mb-2' value={true}>{t("item.changeRateCode.additionalPayment")}</Radio>
                                    </Radio.Group> */}
                                    <div className='col-md-6 ml-4'>
                                        <CoInput
                                            placeholder=""
                                            type={`currency`}
                                            name={`additionalPrice`}
                                            onChange={(e) => this.onChangeAdditionalValue('sellCost', e.target.value)}
                                            value={checkUndefine(additionalPayment.sellCostShow)} 
                                        />
                                    </div>
                                    <div className='col-md-6 ml-4'>
                                        <span className="change-rate-code-cashFlow">{t('item.changeRateCode.inputFt')}</span>
                                        &nbsp;<Tooltip title={ 'Mã FT code dùng để xác nhận' } >
                                            <Icon type="info-circle" />
                                        </Tooltip>
                                        {isErrorFt && <span className="isError">{t('item.changeRateCode.errorFT')}</span>}
                                        <Input placeholder="" type={`text`}
                                            name={`ftCode`} onChange={(e) => this.onChangeValue('ftCode', e.target.value)}
                                            value={checkUndefine(ftCode)} 
                                        />
                                    </div>
                                    <p className="col-md-12 change-rate-addition-cost mt-2 mb-2">
                                        {t("item.changeRateCode.quicklyCreateANewPriceCode")}
                                    </p>
                                    {/* {this.renderInputAdditional({key: 'additionalCode', translate: 'newCodePrice'})} */}
                                    {this.renderInputAdditional({key: 'name', translate: 'nameNewCode'})}

                                    <p className="col-md-12 change-rate-addition-cost">
                                        {t("item.changeRateCode.totalPrice",{totalPrice: Func.formatMoney(additionalPayment?.sellCost)})}
                                    </p>
                                    <p className="col-md-12 change-rate-addition-cost">
                                        {t("item.changeRateCode.priceRounding",{priceRounding: Func.formatMoney(additionalPayment?.rounding)})}
                                    </p>
                                    {this.renderInputAdditional({key: 'roundingShow', translate: 'salePriceRounding', type: 'currency'})}
                                </Wrapper>
                            :   <Wrapper className="col-md-6 mt-15">
                                    <div className="mb-10">
                                        <span className="change-rate-code-cashFlow">{t('item.changeRateCode.inputFt')}</span>
                                        &nbsp;<Tooltip title={ 'Mã FT code dùng để xác nhận' } >
                                            <Icon type="info-circle" />
                                        </Tooltip>
                                        {isErrorFt && <span className="isError">{t('item.changeRateCode.errorFT')}</span>}
                                    </div>
                                    <Input placeholder="" type={`text`}
                                        name={`ftCode`} onChange={(e) => this.onChangeValue('ftCode', e.target.value)}
                                        value={checkUndefine(ftCode)} 
                                    />
                                </Wrapper>
                        }
                    </Wrapper>
                }
            </Modal>
        )
    }

    onHandleRateCode = (item)=>{
        const { isActive, rateCodeSelect } = this.state;
        // const currentIsActive = cloneDeep(isActive);
        const rateSelectCurrent = cloneDeep(rateCodeSelect);

        const newRateSelectCurrent = filter(rateSelectCurrent, (el) => el.id !== item.id);
        const indexSelectItem = findIndex(rateSelectCurrent, (i) => i.id === item.id);
        if (indexSelectItem < 0) { newRateSelectCurrent.push(item) }
        if (newRateSelectCurrent.length > 1) {
            message.error(i18n.t('notification.cantSelectTwoRateCode'))
            return;
        }
        this.setState({ 
            // isActive: newDataActive, 
            rateCodeSelect: newRateSelectCurrent
        });
        // this.setState({isActive: item.id, rateCodeSelect: item})
    }

    onChange = (fieldName, value)=>{
        if(fieldName === 'valueSearch'){
            this.setState({ valueSearch: value, pageIndex: 1 });
            if(this.searchTimer){
                clearTimeout(this.searchTimer);
            }
            this.searchTimer = setTimeout(() => {
                this.loadRateCodes({ pageIndex: 1, searchTerm: value });
            }, 400);
            return;
        }
        if(fieldName === 'campaign'){
            if(this.searchTimer){
                clearTimeout(this.searchTimer);
            }
            this.setState({ campaign: value, valueSearch: '', pageIndex: 1 }, () => {
                this.loadRateCodes({ pageIndex: 1, searchTerm: '', campaignId: value });
            });
            return;
        }
        this.setState({[fieldName]: value});
    }

    onPageChange = (pageIndex) => {
        this.setState({ pageIndex }, () => this.loadRateCodes({ pageIndex }));
    }

    onChangeValue = (fieldName, value)=>{
        this.setState({[fieldName]: value});
    }

    onChangeAdditionalValue = (fieldName, value)=>{
        const { additionalPayment } = this.state;
        let rounding = additionalPayment.rounding;
        if (fieldName === "roundingShow") {
            rounding = value - additionalPayment.sellCost;
        }
        this.setState({
            additionalPayment: {
                ...additionalPayment,
                rounding,
                [fieldName]: value,
            }
        });
    }

    onSubmit = (actionType) => {
        const { rateCodeSelect, ftCode, additionalPayment, rateCodeCurrent } = this.state;
        // if(rateCodeSelect > 0 && rateCodeSelect.id){
        if(rateCodeSelect.length > 0){
            if(actionType === 1){
                const sellCost = sumBy(rateCodeSelect, "sellCost");
                const sellCostShow = sellCost - rateCodeCurrent.sellCost
                this.setState({
                    action: 2,
                    additionalPayment: {
                        sellCost,
                        sellCostShow,
                        roundingShow: sellCost,
                        rounding: 0,
                        additionalCode: '',
                        name: '',
                    }
                });
            }
            if(actionType === 2){
                if(this.validate()){
                    this.props.changeRateCode({
                        orderId: this.props.orderId,
                        itemVariantId: this.props.itemVariantId,
                        rateCodeIds: rateCodeSelect.map(el=> el.id),
                        FTCode: ftCode,
                        rounding: Number(this.state.additionalPayment.rounding),
                        sellCost: this.state.additionalPayment.roundingShow,
                        name: this.state.additionalPayment.name,
                    });
                
                    this.props.onSubmit();
                    this.destroyData();
                }
            }
        }
    }


    onCancel = (actionType) => {
        if(actionType === 2){
            this.setState({ action: 1 });
        }
        if(actionType === 1){
            this.props.onCancel();
            this.destroyData();
        }
    }

    destroyData = () => {
        this.setState({
            isActive: [],
            rateCodeSelect: [],
            action: 1,
            ftCode: '',
            isErrorFt: false,
            additionalPayment: {
                sellCost: 0,
                additionalCode: '',
                name: '',
                rounding: 0
            }
        })
    }

    validate() {
        const { rateCodeSelect, rateCodeCurrent, ftCode } = this.state;
        if(sumBy(rateCodeSelect, 'sellCost') - rateCodeCurrent.sellCost > 0){
            if (!ftCode){
                this.setState({ isErrorFt: true });
                return false;
            }
        }
        return true;
    }
}
